export default "__VITE_ASSET__D5tB7$3I__"